<template>
<div id="reporte_pedimentos_simple" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Reporte de Consulta Pedimentos / Encabezado" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'in-view'" >Vista Previa</v-tab>
            <v-tab :key="'in-report'" >Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="3" md="3" lg="3" >
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="model.tipo_reporte == 4" sm="1" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-text-field v-model="model.rfcs_filtro" label="RFC" prepend-icon="fa-search" maxlength="20"></v-text-field>
                        <!-- <v-autocomplete v-model="model.rfcs_filtro" multiple :items="rfcFiltroAgentes" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="RFC" :rules="[rules.required]">
                        </v-autocomplete> -->
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-autocomplete clearable v-model="model.tipo_operacion" :items="list_tipo_operaciones" :hide-no-data="true" :return-object="false" item-text="tipo" item-value="clave_tipo" label="Tipo Operación" >
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 1" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" maxlength="20"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 3" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu3 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu4 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_reporte == 4" row wrap>
                      <v-col>
                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_reporte == 4" row wrap>
                      <v-col sm="12" md="12" lg="12" >
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <!-- <v-btn v-if="to_download.length > 0 && permisoDescarga" rounded color="info" @click="download_files" :loading="loading" >
                  <v-icon>done</v-icon>Descargar Seleccionados
                </v-btn> -->
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                  <v-icon>done</v-icon>Vista Previa
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                  <template slot="noResults" >
                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                  </template>

                  <div slot="filter__id" v-if="permisoDescarga" >
                    <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()" >
                  </div>
                  <template slot="id" slot-scope="props" v-if="permisoDescarga" >
                    <div style="display:flex; justify-content:center;" >
                      <input :id="props.row.id +'-'+props.row.no_pedimento" type="checkbox" v-model="to_download" :value="props.row.id +'-'+props.row.no_pedimento" ></input>
                    </div>
                  </template>

                  <template slot="actions_view" slot-scope="props" >
                    <v-speed-dial :id="'id-2'" direction="left" open-on-hover :style="'text-align:center;'" >
                      <template v-slot:activator>
                        <v-btn :id="'id-2'" x-small fab dark color="primary" >
                          <v-icon>reorder</v-icon>
                        </v-btn>
                      </template>

                      <v-btn x-small fab dark color="green" v-if="props.row.xml && permisoDescarga" @click="downloadFile(props.row.xml)" title="XML Pedimento" v-tippy>
                        <v-icon>code</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="red" v-if="props.row.pdf  && permisoDescarga" @click="downloadFile(props.row.pdf)" title="PDF Pedimento" v-tippy>
                        <v-icon>picture_as_pdf</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="red" v-if="props.row.pdf_s" @click="downloadFile(props.row.pdf_s)" title="PDF Pedimento Simplificado" v-tippy>
                        <v-icon>picture_as_pdf</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="purple darken-4" v-if="props.row.zip  && permisoDescarga" title="Zip" @click="generateZip(props.row.zip)" v-tippy>
                        <v-icon>unarchive</v-icon>
                      </v-btn>

                    </v-speed-dial>
                  </template>

                  <template slot="valor_comercial" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.valor_comercial, 4)}}
                    </div>
                  </template>
                  <template slot="fletes" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.fletes, 4)}}
                    </div>
                  </template>
                  <template slot="seguros" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.seguros, 4)}}
                    </div>
                  </template>
                  <template slot="embalajes" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.embalajes, 4)}}
                    </div>
                  </template>
                  <template slot="incrementables" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.incrementables, 4)}}
                    </div>
                  </template>
                  <template slot="tipo_cambio" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.tipo_cambio, 4)}}
                    </div>
                  </template>
                  <template slot="peso_bruto" slot-scope="props" >
                    <div class="text-number" >
                      {{props.row.peso_bruto}}
                    </div>
                  </template>

                </v-client-table>
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="'in-report'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="3" md="3" lg="3" >
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="model.tipo_reporte == 4" sm="1" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-text-field v-model="model.rfcs_filtro" label="RFC" prepend-icon="fa-search" maxlength="20"></v-text-field>
                        <!-- <v-autocomplete v-model="model.rfcs_filtro" multiple :items="rfcFiltroAgentes" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="RFC" :rules="[rules.required]">
                        </v-autocomplete> -->
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-autocomplete clearable v-model="model.tipo_operacion" :items="list_tipo_operaciones" :hide-no-data="true" :return-object="false" item-text="tipo" item-value="clave_tipo" label="Tipo Operación" >
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 1" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" maxlength="20"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 3" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu1 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu2 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_reporte == 4" row wrap>
                      <v-col sm="12" md="12" lg="12" >
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="generar_reporte_sqs" :loading="loading" >
                  <v-icon>done</v-icon>Generar Reporte
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-refresh-button :funcion="cargar" />

                <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                  <template slot="noResults" >
                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="actions" slot-scope="props" >
                    <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                    <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista='';dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc_grupo = this.model.rfc = this.$local_storage.get("rfc_grupo");
    this.model.id_grupo = this.$local_storage.get("id_grupo");
    this.rfcFiltroAgentes = this.get_clientes_grupo();
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
        this.permisoEliminar = true;
    var userSubtipo = this.$local_storage.get("subtipo_usuario","");
    if (userSubtipo != ""){
        if (userSubtipo == "agentes_de_carga" || userSubtipo == "transportistas")
          this.permisoDescarga = false;
    }
    this.cargar();
  },
  data: () => ({
    rfcFiltroAgentes:[],
    permisoEliminar: false,
    permisoDescarga: true,
    tab: null,
    lista_filtrada: [],
    dialog1: false,
    allChecked: false,
    to_download: [],
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes de Pedimentos",
        disabled: true,
        to: ""
      }
    ],
    list_tipo_operaciones: [{
        "tipo": "Importación",
        "clave_tipo": "1"
      },
      {
        "tipo": "Exportación",
        "clave_tipo": "2"
      },
    ],
    tipos: [{
      "id": 1,
      "text": "Por Pedimento"
    }, {
      "id": 3,
      "text": "Por Fechas"
    }, {
      "id": 4,
      "text": "Por Lista de Pedimentos"
    }],
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: true,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      pedimento: "",
      fecha_de: "",
      fecha_a: "",
      lista: "",
      reporte_url: "/reportes_vucem/consultar_pedimentos_simple_agentes/",
      nombre_reporte: "Pedimentos Detalle",
      tipo: "Pedimentos Detalle Agentes",
      tipo_reporte: "",
      tipo_operacion: "",
      id_grupo: 0,
      rfc_grupo: "",
      rfcs_filtro:""

    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    data_view: {
      datos: [],
      columns: ['id', 'rfc', 'no_pedimento','fecha_pago', 'fecha_original', 'fecha_entrada',
        'anio','mes','tipo_operacion', 'tipo_pedimento', 'clave_documento', 'seccion_aduanera', 'patente',
        'valor_comercial', 'fletes', 'seguros', 'embalajes', 'incrementables', 'tipo_cambio',
        'peso_bruto','pc_rc', 'conteo_partidas', 'conteo_coves','conteo_edocs', 'conteo_remesas',
         'transporte','parte_dos','contingencia','subestado',  'actions_view'
      ],
      options: {
        filterable: ['rfc', 'no_pedimento', 'fecha_entrada', 'fecha_pago','pc_rc',
          'clave_documento', 'tipo_operacion', 'tipo_pedimento','subestado','parte_dos','contingencia'],
        sortable: ['no_pedimento', 'fecha_entrada', 'fecha_pago','pc_rc',
          'clave_documento', 'tipo_operacion', 'tipo_pedimento','subestado','parte_dos','contingencia'],
        headings: {
          id: '',
          rfc: 'RFC',
          'referencia':'ID Planta-Referencia',
          no_pedimento: 'No Pedimento',
          fecha_pago: 'Fecha Pago Real',
          fecha_original: 'Fecha Original',
          fecha_entrada: 'Fecha de Entrada / Presentación',
          anio:"Año",
          mes:"Mes",
          tipo_operacion: 'Tipo Operación',
          tipo_pedimento: 'Tipo Pedimento',
          clave_documento: 'Clave Documento',
          seccion_aduanera: 'Sección Aduanera',
          patente: 'Patente',
          valor_comercial: 'Valor Comercial',
          fletes: 'Fletes',
          seguros: 'Seguros',
          embalajes: 'Embalajes',
          incrementables: 'Incrementables',
          tipo_cambio: 'Tipo Cambio',
          peso_bruto: 'Peso Bruto',
          pc_rc:"ID PC-RC",
          conteo_partidas: 'Conteo Partidas',
          conteo_coves: 'Conteo Coves',
          conteo_edocs: 'Conteo Edocuments',
          conteo_remesas: 'Conteo Remesas',
          transporte: 'Medio Entrada-Salida',
          parte_dos:"ID Parte 2",
          contingencia:"ID Contingencia",
          subestado: 'Estado de Pedimento',
          actions_view: 'Documentos'
        }
      }
    }
  }),
  methods: {
    validaFecha: function(fecha){
        if (fecha == "Invalid date")
            return "Fecha no válida.";
        else
          return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar.";
      }
      return true;
    },
    maxListaRule: function() {
      if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
        return "Lista vacia";
      }

      let x = this.model.lista.split("\n");

      if (x.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      }

      return true;
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.model.tipo
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if (params.tipo_reporte == 1) {
            return "Pedimento: " + params.pedimento;
          } else if (params.tipo_reporte == 3) {
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          } else {
            return "Búsqueda por lista";
          }
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    get_data_view: function() {
      if (!this.$refs.form1.validate()) {
        //Alguna operación o mensaje
      } else {
        if (this.model.tipo_reporte == 4 && this.model.lista == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;

        if(data.rfcs_filtro != "" && data.rfcs_filtro != null && data.rfcs_filtro != undefined) {
          data.rfcs_filtro = [data.rfcs_filtro];
        } else {
          data.rfcs_filtro = [];
        }

        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.lista == '' || data.lista == []) {
          delete(data['lista'])
        } else {
          if (data.tipo_reporte == 4) {
            data['lista'] = this.get_array_lista(data['lista'])
          }
        }
        data['preview'] = true;

        axios({
            method: "post",
            url: this.$hostname + "reportes_vucem/consultar_pedimentos_simple_agentes/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.data_view.datos = response.data;
              this.data_view.datos = this.data_view.datos.sort( ( a, b) => {
                  return new Date(a.fecha_pago) - new Date(b.fecha_pago) ;
              });
            if (data.tipo_reporte == 4) {
              this.model.lista = '';
              this.lista_filtrada = [];
            }
          })
          .catch(error => {
            console.log(error);
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.model.rfcs_filtro = "";
            this.$root.$dialogLoader.hide();
          });
      }
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        if (this.model.tipo_reporte == 4 && this.model.lista == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.lista == '' || data.lista == []) {
          delete(data['lista']);
        } else {
          if (data.tipo_reporte == 4) {
            data['lista'] = this.get_array_lista(data['lista']);
          }
        }

        if(data.rfcs_filtro != "" && data.rfcs_filtro != null && data.rfcs_filtro != undefined) {
          data.rfcs_filtro = [data.rfcs_filtro];
        } else {
          data.rfcs_filtro = [];
        }

        data['preview'] = false;

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            if (data.tipo_reporte == 4) {
              this.model.lista = '';
              this.lista_filtrada = [];
            }
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
                mensaje = error.response.data.mensaje;
                if (error.response.status == 406){
                    titulo = "¡Ya existe un reporte en proceso!";
                    tipo = "info";
                }
            } else {
                mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
                type: tipo,
                title: titulo,
                text: mensaje,
                footer: ""
            });
          }).then(() => {
            this.model.rfcs_filtro = "";
            this.cargar();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    get_clientes_grupo: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
          usuario: this.$local_storage.get("id_usuario"),
          sistema: this.$sistema,
      };

      axios.post(this.$hostname + "usuarios/get_clientes_grupo/", data)
        .then(res => {
          if (res.data != undefined) {
            this.rfcFiltroAgentes= res.data;
          } else {
            this.rfcFiltroAgentes = [];
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los RFC del Grupo.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generateZip: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        key: key,
        usuario: this.$local_storage.get("id_usuario"),
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_zip/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            this.$swal({
              type: "info",
              title: "Generado...",
              text: "En breve recibirás una notificación para descargar el ZIP",
              footer: '',
            });
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    check_all: function() {
      let arr = this.allChecked ? this.data_view.datos.map(row => row.id + "-" + row.no_pedimento) : [];
      if (arr.length == 0) {
        this.to_download = [];
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (this.to_download.includes(arr[i])) {
            continue;
          } else {
            this.to_download.push(arr[i]);
          }
        }
      }

    },
    download_files: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      var data = {
        rfc: this.model.rfc,
        usuario: this.model.usuario,
        pedimento: this.model.pedimento,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a,
        lista: this.model.lista,
        reporte_url: "/reportes_vucem/genera_zip/",
        nombre_reporte: "Zip Pedimentos WS",
        tipo: this.model.tipo,
        tipo_reporte: this.model.tipo_reporte,
        files: this.to_download
      };

      if (data.pedimento == '') delete(data['pedimento']);
      if (data.archivo == '') delete(data['archivo']);
      if (data.fecha_de == '') delete(data['fecha_de']);
      if (data.fecha_a == '') delete(data['fecha_a']);
      if (data.lista == '' || data.lista == []) {
        delete(data['lista'])
      } else {
        if (data.tipo_reporte == 4) {
          data['lista'] = this.get_array_lista(data['lista'])
        }
      }

      axios({
          method: "post",
          url: this.$hostname + "reportes/save_reporte/",
          data: data
        })
        .then(response => {
          this.to_download = [];
          if (data.tipo_reporte == 4) {
            this.model.lista = '';
            this.lista_filtrada = [];
          }
          this.$swal({
            type: "success",
            title: "Operación Exitosa",
            text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
            footer: ""
          });
        })
        .catch(error => {
          let mensaje;
          var titulo = "¡Operación no Permitida!";
          var tipo = "error";
          if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406){
                  titulo = "¡Ya existe un reporte en proceso!";
                  tipo = "info";
              }
          } else {
              mensaje = "Ocurrió un error al generar el reporte";
          }
          this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
          });
        }).then(() => {
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
    },
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      let data = cadena.split("\n");
      let newarr = data.filter(a => a.trim() !== '');
      for (var i = 0; i < newarr.length; i++) {
        newarr[i] = newarr[i].trim();
        newarr[i] = newarr[i].replace(',', '');
        newarr[i] = newarr[i].replace('.', '');
      }

      return newarr;
    },
    formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
    eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
              }
          });
        },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small ;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small ;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.text-number {
    text-align: right;
}
</style>
